/* global Autodesk, THREE */ // eslint-disable-line

import store from "../../helpers/store/Store";
import {
  properties,
  showObjProperties
} from "../../helpers/actions/Action";
import {
  attributes,
  allCategories
} from '../../App'

function PropertyExtension(viewer, options) {
  Autodesk.Viewing.Extension.call(this, viewer, options);
}

PropertyExtension.prototype = Object.create(Autodesk.Viewing.Extension.prototype);
PropertyExtension.prototype.constructor = PropertyExtension;

PropertyExtension.prototype.load = function () {
  let properties = new prop(this.viewer)
  this.viewer.addEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, (e) => properties.onSelectionChanged(e, this.viewer))
  return true;
};

PropertyExtension.prototype.unload = function () {
  return true;
};

Autodesk.Viewing.theExtensionManager.registerExtension('PropertyExtension', PropertyExtension);

class prop {
  constructor(viewer) {
    this.viewer = viewer;
  }

  checkIfPushPinToggleIsInactive = () => {
    let activeModel = store.getState().getModelArrayReducer.data.filter((model) => {
      if(model.selected === true) {
        return model;
      }
    });

    let pushpinButtonClassList = document.getElementById("pushpin-toggle-" + activeModel[0].id).classList;
    let pushpinIsInActive = pushpinButtonClassList.contains("inactive") || pushpinButtonClassList.contains("disabled") ? true : false
    return pushpinIsInActive;
  }

  mapData = (data, id) => {
    let filterMap = attributes()
    let filterCategory = allCategories()
    let categories = [];
    let sortedData = data

    let found = false

    let hyperlink = data.properties.filter((item) => {
      if (item.displayName.toLocaleLowerCase() === 'hyperlink') {
        return item
      } else {
        return null
      }
    })
    let info = data.properties.filter((item) => {
      if (item.displayName.toLocaleLowerCase() === 'info_ref') {
        return item
      } else {
        return null
      }
    })
    if (hyperlink.length !== 0) {
      const propData = [{ category: hyperlink[0].displayName, data: { displayValue: hyperlink[0].displayValue, displayName: info[0].displayValue } }]
      //console.log("properties", propData, id);
      if (this.checkIfPushPinToggleIsInactive()) {
        store.dispatch(properties({ id: id, data: propData }))
        store.dispatch(showObjProperties({ id: id, show: true }))
      }

      found = true;
    }


    if (filterCategory !== null) {
      filterCategory.forEach((obj) => {
        if (!found) {
          let autocad = data.properties.filter((item) => {
            if (item.displayCategory !== null) {
              return item.displayCategory.toLocaleLowerCase() === obj.toLocaleLowerCase()
            } else {
              return null
            }
          })
          found = autocad.length > 0 ? true : false
        } else {
          return null
        }
      })
    }

    if (found && hyperlink.length === 0) {
      if (filterMap !== null) {
        filterMap.map((category, index) => {
          let categoryData = [];
          category.data.map((obj, index) => {
            let filterd = sortedData.properties.filter((item) => {
              let check = true;
              if (typeof item.displayValue === 'string') {
                check = item.displayValue !== ''
                check ? check = item.displayValue.toLocaleLowerCase() !== 'none' : check = false
              }
              
              if (item.units === 'mm^2' && (typeof item.displayValue) =='number') {
                item.displayValue = (item.displayValue/1000000).toFixed(3);
                item.units = 'm^2';
              } else if (item.units === 'mm^3' && (typeof item.displayValue) =='number') {
                item.displayValue = (item.displayValue/1000000000).toFixed(3);
                item.units = 'm^3';
              } else if (item.units === 'm^2' && (typeof item.displayValue) =='number') {
                item.displayValue = (item.displayValue).toFixed(3);
              } else if (item.units === 'm^3' && (typeof item.displayValue) =='number') {
                item.displayValue = (item.displayValue).toFixed(3);
              } else if (item.units === 'mm' && (typeof item.displayValue) =='number' && item.displayName.includes('Elevation')) {
                item.displayValue = (item.displayValue/1000).toFixed(3);
                item.units = 'm';
              }

              let correctDataSet = filterCategory.includes(item.displayCategory)
              return (
                item.displayName === obj.type &&
                check === true &&
                item.displayValue !== null &&
                correctDataSet === true &&
                item.displayValue !== 0 &&
                item.displayValue !== 0.0 &&
                item.displayValue !== 0.00 &&
                item.displayValue !== 0.000 &&
                item.displayValue !== '0' &&
                item.displayValue !== '0.0' &&
                item.displayValue !== '0.00' &&
                item.displayValue !== '0.000'            
              )
            })
            if (filterd.length !== 0) {
              categoryData.push({ data: filterd });
            }
            return null
          })

          categories.push({ category: category.category, data: categoryData });
          return null
        })
      }

      //console.log("properties", categories, id);
      this.checkIfPushPinToggleIsInactive()
      if (this.checkIfPushPinToggleIsInactive()) {
        store.dispatch(properties({ id: id, data: categories }))
        store.dispatch(showObjProperties({ id: id, show: true }))
      }
    } else if (hyperlink.length === 0) {
      let instanceTree = this.viewer.model.getData().instanceTree;
      let parentId = instanceTree.getNodeParentId(data.dbId)

      this.viewer.getProperties(parentId, this.propCallbackSuccess, this.propCallbackFailure)
    }
  }

  propCallbackSuccess = (data) => {
    let properties = new prop(this.viewer)
    properties.mapData(data, this.viewer.config.id)
  }

  propCallbackFailure = (data) => {
    let id = this.viewer.config.id;
    //console.log("properties", id);
    if (this.checkIfPushPinToggleIsInactive()) {
      store.dispatch(properties({ id: id, data: [] }))
      store.dispatch(showObjProperties({ id: id, show: true }))
    }
  }

  onSelectionChanged = (event, view) => {
    if (event.dbIdArray.length === 1) {
      view.getProperties(event.dbIdArray[0], function (data) {
        let properties = new prop(view)
        properties.mapData(data, view.config.id)
      })
    }
  }
}

